import { PageContainer } from "@shapr3d/frontend-lib";

import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";
import VerifyEmailContainer from "../containers/VerifyEmailContainer";

const EduRequestPage = () => {
  return (
    <UnderMaintenanceOrChildren>
      <PageContainer>
        <VerifyEmailContainer />
      </PageContainer>
    </UnderMaintenanceOrChildren>
  );
};

export default EduRequestPage;
